import { useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';

var Portal = function (_a) {
    var children = _a.children, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId;
    var portalEl = useMemo(function () {
      return Object.assign(document.createElement("div"), {
        className: 'panwds-tw3' // <== added scope
      });
    }, []);
    portalEl.setAttribute("data-testid", dataTestId || "portal");
    dataMetrics && portalEl.setAttribute("data-metrics", dataMetrics);
    useEffect(function () {
        (document.body._sparky_portals_tw3 || document.body).appendChild(portalEl);
        return function () {
          portalEl.parentNode.removeChild(portalEl);
        };
    }, []);
    return createPortal(children, portalEl);
};

export { Portal };
